// extracted by mini-css-extract-plugin
export default {"wrap":"SearchInputComponentModal_wrap__oNAOj","searchInput":"SearchInputComponentModal_searchInput__5vyY0"};